<template>
    <section>
        <AppBackground :title="title"/>
        <v-container>
            <v-row>
                <v-col>
                    <iframe class="v-form" scrolling="no" src="https://docs.google.com/forms/d/e/1FAIpQLSdZ368l-GJBfDHzuD19VD4ZBeMSfHfLdBIDBy-nfi3v6y0qCQ/viewform?embedded=true" width="100%" frameborder="0" marginheight="0" marginwidth="0">読み込んでいます…</iframe>
                </v-col>
            </v-row>
        </v-container>
    </section>
</template>

<script>
import AppBackground from './AppBackgroundHolder.vue'

export default {
    name: 'Contact',
    data () {
        return {
            title:'お問い合わせ',
        }
    },
    components: {
        AppBackground
    }
}
</script>

<style lang="scss" scoped>
.v-form {
    height: 1200px;
}
</style>
